module.exports = "<p>\n  message-index works!\n</p>\n"